// header
export { default as Header } from './Header';

// body
export { default as CommonInfo } from './CommonInfo';
export { default as AboutCompany } from './AboutCompany';
export { default as Locations } from './Locations';
export { default as Map } from './Map';
export { default as Carousel } from './Carousel';
export { default as Advantages } from './Advantages';
export { default as WhyWe } from './WhyWe';
export { default as Partnerships } from './Partnerships';
export { default as Feedback } from './Feedback';
export { default as FeedbackDesktop } from './FeedbackDesktop';
export { default as FeedbackMobile } from './FeedbackMobile';
export { default as ApplyToJoin } from './ApplyToJoin';
export { default as JoinPageContent } from './JoinPageContent';
export { default as ContactUs } from './ContactUs';
export { default as JoinForm } from './JoinForm';
export { default as ChatWithUs } from './ChatWithUs';
export { default as ApplyToJoinEmail } from './ApplyToJoinEmail';
export { default as ThankYouPageContent } from './ThankYouPageContent';
export { default as PrivacyPolicyPageContent } from './PrivacyPolicyPageContent';
export { default as TermsAndConditionsPageContent } from './TermsAndConditionsPageContent';

// footer
export { default as Footer } from './Footer';

// Error & PageNotFound layout
export { default as ErrorLayout } from './ErrorLayout';
